<template>
  <nuxt-link
    :data-type="`package-${item.uuid}`"
    :to="{
      name: 'product-permalink',
      params: {
        type: $t(`router.product_permalink.type.${item.type}`),
        permalink: item.permalink,
      },
    }"
  >
    <span class="item-search-title">{{ item.name }}</span
    ><br />
    <span class="item-search-description">{{ item.headline }}</span>
  </nuxt-link>
</template>

<script>
import LadSearchCommon from './common'

export default {
  name: 'LadSearchPackage',
  extends: LadSearchCommon,
}
</script>
